import { text } from "../utils/i18n";
import Team from "./Team";

export type ProductConfigGetDescriptionParams = {
  teams: Team[];
}

/**
 * Product properties per team.
 */
export class ProductConfig {
  readonly price?: number;
  readonly priceMin?: number;
  readonly priceMax?: number;
  readonly priceOptions: number[] = [];
  readonly teamIds: string[] = [];

  constructor(deriveFrom?: Partial<ProductConfig>) {
    if (deriveFrom) {
      Object.assign(this, deriveFrom);
    }
  }

  getDescription(args: ProductConfigGetDescriptionParams): string {
    const teams = args.teams.filter(team => this.teamIds.includes(team.id));

    if (!teams.length) {
      return text`Administratör`;
    }

    return teams.map(team => team.name).join(', ');
  }
}